import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {UpgradeLandingView} from "../components/upgrade/UpgradeLandingView";
import {NavBarLanding} from "../components/navBars/NavBarLanding";

const Upgrade: NextPage = () => {
  return <>
    <Head>
      <title>Upgrade</title>
    </Head>
    <div className="flex flex-col overflow-x-hidden">
      <NavBarLanding />
      <UpgradeLandingView />
    </div>
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate', 'subscription']),
    }
  }
});

export default Upgrade